import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="section">
      <div className="container">
        <div className="connect-card">
          <h3 className="contact-title">Let's Connect</h3>
          <p className="muted" style={{ maxWidth: 680 }}>
            I'm always open to discussing new opportunities, collaborations, or just connecting with fellow developers. 
            Feel free to reach out via email at shubha.pradhan12@gmail.com or connect with me on social platforms.
          </p>
          <p className="muted" style={{ maxWidth: 680, marginTop: 12 }}>
            Follow my journey and stay updated with my latest projects and thoughts on AI, backend engineering, and technology.
          </p>
          <div className="socials">
            <a className="btn social-btn" href="mailto:shubha.pradhan12@gmail.com">Email</a>
            <a className="btn social-btn" href="https://github.com/shubhajeet1207" target="_blank" rel="noreferrer">GitHub</a>
            <a className="btn social-btn" href="https://www.linkedin.com/in/shubhajeet-pradhan" target="_blank" rel="noreferrer">LinkedIn</a>
            <a className="btn social-btn" href="https://shubhajeetpradhan.netlify.app" target="_blank" rel="noreferrer">Blog</a>
          </div>
        </div>
      </div>
    </section>
  );
}
